import { Policy } from '@commandDrivenStateEngine/core/policies';
import { AccountState } from '../state';
import { AccountCommand } from '../commands';
import { ClientLibraryType } from '@bett3r-dev/teselly-client-library';
import { fetchMembershipRoles } from './fetchMembershipRoles';
/**
 * Users Fetch Policy
 *
 * Responsibilities:
 * - Fetch users profiles on init
 * - Fetch per-membership roles from AuthUserSecurityReadmodel
 * - Dispatch data/setAll and data/setMembershipRoles
 * - Handle loading states
 */
export const createUsersFetchPolicy = (
  backend: ClientLibraryType,
  accountId: string
): Policy<AccountState, AccountCommand> => ({
  name: 'users-fetch',

  init: ({ dispatch }) => {
    console.log( '[account] Initializing users fetch policy' );

    ( async () => {
      dispatch(
        { type: 'account/users/loading/setFetching', payload: { isLoading: true }},
        { source: 'api' }
      );

      try {
        const response = await backend.queries.UsersProfiles();

        if ( response && Array.isArray( response )) {
          dispatch(
            { type: 'account/users/data/setAll', payload: { users: response }},
            { source: 'api' }
          );

          const userIds = response.map(( u: any ) => u.id ).filter( Boolean );
          if ( userIds.length > 0 ) {
            try {
              const membershipRoles = await fetchMembershipRoles( backend, accountId, userIds );
              dispatch(
                { type: 'account/users/data/setMembershipRoles', payload: { membershipRoles }},
                { source: 'api' }
              );
            } catch ( error ) {
              console.error( '[account] Membership roles fetch error:', error );
            }
          }
        }
      } catch ( error ) {
        console.error( '[account] Users fetch error:', error );
      } finally {
        dispatch(
          { type: 'account/users/loading/setFetching', payload: { isLoading: false }},
          { source: 'api' }
        );
      }
    })();

    return undefined;
  }
});
